import { store } from '@/store'
import * as actions from '@/store/ActionTypes'

export default (to, from, next) => {
  if (store.getters.user && (store.getters.user.vbl || store.getters.user.roles.includes('data'))) {
    next()
  } else {
    store.dispatch(actions.UNLOAD_USER).then(() => {
      next('/signin?returnUrl=' + to.fullPath)
    })
  }
}
